import React from 'react';
import PropTypes from 'prop-types';
import { Markup } from 'interweave';
import { getProfileVisibility } from '../../../../helpers/getProfileVisibility';
import { useLoggedOutAthletePageContext } from '../../../../state/LoggedOutAthletePageContext';
import styles from './Trophy.module.scss';

const Trophy = ({ trophy }) => {
  const { state, track } = useLoggedOutAthletePageContext();
  const { athleteData } = state;
  const { athlete } = athleteData;
  const { url, teaser, logo_url: logoUrl, name, date, effort, rank } = trophy;

  const handleTrack = () => {
    track({
      action: 'click',
      element: 'challenge',
      properties: {
        profile_visibility: getProfileVisibility(athlete)
      }
    });
  };

  return (
    <a
      href={`/challenges/${url}`}
      title={teaser}
      className={styles.trophy}
      onClick={handleTrack}
    >
      <img
        src={logoUrl}
        alt={name}
        className={styles.trophyImage}
        data-testid="trophy-image"
      />

      <div className={styles.description}>
        <h4>{name}</h4>
        <time className={styles.timestamp}>{date}</time>
        {effort && <Markup className={styles.effort} content={effort} />}
        {rank && <div className="rank">{rank}</div>}
      </div>
    </a>
  );
};

Trophy.propTypes = {
  trophy: PropTypes.shape({
    url: PropTypes.string.isRequired,
    logo_url: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    teaser: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    challenge_id: PropTypes.number.isRequired,
    effort: PropTypes.string,
    rank: PropTypes.string
  }).isRequired
};

export default Trophy;
